export default "__VITE_ASSET__77b9ab79__"